import { ELevel } from '@/services/Menus'

export default class ComponentState {
  public snackbar: Array<{
    id: string,
    txt: string,
    type: string,
  }>
  public titlePage: string
  public app: string
  public pageLoading: boolean
  public user: {
    level: {
      id?: string,
      mode: string,
    },
  }
  public ready: boolean
  constructor() {
    this.snackbar = []
    this.app = ''
    this.pageLoading = false
    this.titlePage = ''
    this.ready = false
    this.user = {
      level: {
        mode: 'user',
      },
    }
  }
}

export interface IDialogOption {
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between'
  form?: any
  button: {
    width?: number,
    height?: number,
    outlined?: boolean,
    justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between',
    [key: string]: {
      title?: string,
      action?: () => void,
      disable?: boolean,
      loading: boolean,
      notValidate?: boolean,
    } | any,
  },
}

export interface IBank {
  name: string,
  text: string
}
